import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

export default function LandingPage() {
  const [slugInput, setSlugInput] = useState("");
  const navigate = useNavigate();

  const handleSubmit = () => {
    const trimmed = slugInput.trim();
    if (trimmed) {
      navigate(`/${trimmed}`);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") handleSubmit();
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
      <Card className="w-full max-w-md p-6 space-y-4 bg-white dark:bg-gray-800">
        <h2 className="text-2xl font-bold text-center">Enter Tenant Code</h2>
        <input
          type="text"
          placeholder="Tenant Slug"
          value={slugInput}
          onChange={(e) => setSlugInput(e.target.value)}
          onKeyDown={handleKeyPress}
          className="w-full p-3 border border-gray-300 rounded bg-white dark:bg-gray-700 text-black dark:text-white"
        />
        <Button className="w-full" onClick={handleSubmit}>
          Proceed
        </Button>
      </Card>
    </div>
  );
}